<template>
	<div>
		<div class="bg-gray-50">
			<ContainedSection
				:has-padding="false"
				:has-background="true"
				background-color="bg-white"
			>
				<TwoColumns
					:has-padding-first-column="true"
					column-gap="space-y-0"
				>
					<template #first>
						<BreadcrumbNavigation :crumbs="crumbs" />

						<h1 class="mt-8">Novated subscription</h1>
						<div class="flex flex-col gap-4">
							<p
								class="font-body text-2xl font-medium leading-none text-gray-700"
							>
								Drive smarter business: Explore the benefits of
								novated subscription
							</p>
							<p>
								Join hundreds of Australian businesses who
								choose flexible and affordable car subscription
								over the long term commitment of a traditional
								car leasing or novated leasing.
							</p>
							<p>
								Carbar offers more than just your standard
								business car subscription. Choose to subscribe
								to a fleet of vehicles or potentially pass
								tax-effective benefits to employees by salary
								sacrificing a novated car subscription.
							</p>
							<p>
								We believe that the way you access cars should
								flex with your business needs.
							</p>
						</div>
					</template>

					<template #second>
						<BusinessRegister />
					</template>
				</TwoColumns>
			</ContainedSection>

			<ContainedSection :has-background="true" class="mt-8 md:mt-0">
				<TwoColumns
					first-column-class="flex items-center order-last lg:order-first"
				>
					<template #first>
						<div class="my-8 flex flex-col lg:mt-0">
							<h2>Why novated subscription?</h2>
							<p>
								Novated subscription offers several benefits
								that make it an attractive option for both
								businesses and employees
							</p>
						</div>
					</template>
					<template #second>
						<div class="flex items-center justify-center">
							<CarbarImage
								image="img/business/novated/img-why-novated.webp"
								alt-text="Why novated lease"
							/>
						</div>
					</template>
				</TwoColumns>
				<div
					class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4"
				>
					<div
						v-for="(item, key) in whyNovatedSubscription"
						:key="key"
					>
						<h3 class="font-body font-medium text-gray-700">
							{{ item.head }}
						</h3>
						<p class="mt-2.5 text-lg text-gray-575">
							{{ item.content }}
						</p>
					</div>
				</div>
			</ContainedSection>

			<BusinessCta />

			<ContainedSection>
				<FaqsCarSubscription />
			</ContainedSection>

			<ContainedSection :has-padding="false">
				<NovatedRelatedProducts
					title1="Novated subscription"
					desc1="Drive smarter business: Explore the benefits of novated and
					subscriptions"
					cta1="Find out more on novated subscription"
					href1="/business/novated-subscription"
					title2="Novated EV subscription"
					desc2="A flexible, tax effective way to salary package on EV!"
					cta2="Find out more on novated EV subscription"
					href2="/business/novated-ev-subscription"
				/>
			</ContainedSection>
		</div>
	</div>
</template>

<script setup>
import ContainedSection from '@/components/sections/ContainedSection.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import BreadcrumbNavigation from '@/components/breadcrumbs/BreadcrumbNavigation.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import BusinessRegister from '@/components/business/BusinessRegister.vue'
import NovatedRelatedProducts from '@/components/business/novated/NovatedRelatedProducts.vue'
import FaqsCarSubscription from '@/components/car-subscriptions/FaqsCarSubscription.vue'
import BusinessCta from '@/components/business/BusinessCta.vue'

const crumbs = [
	{
		title: 'Home',
		url: '/',
	},
	{
		title: 'Business',
		url: '/business',
	},
	{
		title: 'Novated subscription',
	},
]

const whyNovatedSubscription = [
	{
		head: 'Tax savings',
		content:
			'Combining a novated lease and car subscription can offer tax benefits while enjoying the flexibility of a subscription service.',
	},
	{
		head: 'Flexibility and freedom',
		content:
			'Novated subscription offers flexibility in vehicle choice and subscription terms, allowing you to switch or terminate your subscription as needed.',
	},
	{
		head: 'Convenience and cost control',
		content:
			'Enjoy the convenience of having maintenance, insurance and other services included in one monthly payment.',
	},
	{
		head: 'No long-term commitment',
		content:
			'Drive the car you want without being locked into long-term contracts',
	},
]
</script>
